import { FC, ReactNode } from 'react';

import { UserRole } from '../generated/graphql';
import { useAppSelector } from '../store/store';

type RestrictedProps = {
  children: ReactNode;
  roles: UserRole[];
  fallback?: ReactNode;
};

export const Restricted: FC<RestrictedProps> = ({
  children,
  roles,
  fallback,
}) => {
  const availableProfiles = useAppSelector((state) => state.user.roles);

  const userHasRequiredRole = availableProfiles?.some(
    (role: UserRole) => roles.indexOf(role) >= 0,
  );

  if (!userHasRequiredRole) {
    return <>{fallback}</>;
  }

  return children;
};
